<template>
  <div class="scroll-wrapper sm:hidden md:block" ref="container">
    <div v-for="(item, index) in content" :key="index" class="scroll-item">
      <router-link v-if="item.url && item.type === 'imatge'" :to="item.url">
        <img :src="item.inside" :alt="'Image ' + index" class="image content" />
      </router-link>
      <div v-else-if="item.type === 'text'" class="text-scroll content">
        <p v-if="item.inside === 'horizontalScroll'" class="w-[40%] text-2xl">
          Pots descobrir més sobre els meus
          <span
            class="link underline hover:cursor-pointer"
            @click="notifyParent('projectes')"
            >projectes</span
          >
          o conèixer una mica més sobre
          <span
            class="link underline hover:cursor-pointer"
            @click="notifyParent('mi')"
            >mi</span
          >.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    projectsVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      content: [
        { type: "imatge", inside: "img/anomala/anomala1.png", url: "/anomala" },
        { type: "imatge", inside: "img/shots1.png", url: "/wildtech" },
        { type: "imatge", inside: "img/shots2.png", url: "/sense" },
        {
          type: "text",
          inside: "horizontalScroll",
          url: "/",
        },
      ],
      scrollAnim: null,
    };
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    this.initScrollAnimation();
  },
  watch: {
    isVisible(newVal) {
      console.log("isVisible changed:", newVal);
      this.updateScrollAnimation();
    },
    projectsVisible(newVal) {
      console.log("projectsVisible changed:", newVal);
      this.updateScrollAnimation();
    },
  },
  methods: {
    initScrollAnimation() {
      const container = this.$refs.container; // Referencia al contenedor
      const images = container.children; // Selección de las imágenes
      const amount = images.length - 1;

      gsap.set(images, {
        xPercent: 70, // Todas las imágenes fuera de la vista hacia la derecha
      });

      this.scrollAnim = gsap.to(images, {
        xPercent: -100 * amount,
        ease: "none", // Sin transición de suavizado
        scrollTrigger: {
          trigger: container, // El contenedor actúa como "trigger"
          pin: true,
          scrub: 1,
          amount: 1 / 2,
          start: "top top",
          end: () => "+=" + container.offsetWidth,
          markers: false,
        },
      });
    },
    updateScrollAnimation() {
      if (this.scrollAnim) {
        if (this.isVisible || this.projectsVisible) {
          this.scrollAnim.progress(0).kill();
        } else {
          this.initScrollAnimation();
        }
      }
    },
    notifyParent(target) {
      this.$emit("word-clicked", target);
    },
  },
};
</script>

<style>
.scroll-wrapper {
  display: flex !important;
  flex-wrap: nowrap !important;
  height: 100vh;
}
.scroll-item {
  flex: 0 0 100vw; /* Cada elemento ocupa el 100% del ancho */
  height: 100%;
  width: max-content;
}

.image {
  width: auto;
  height: 100%;
}

.text-scroll {
  width: 100vw;
  height: 100%;
  color: var(--text-color);
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}

router-link {
  display: contents;
}

.link {
  cursor: pointer;
}
</style>
